/**
 * Specifies the chart constant value
 */
/** @private */
export var loaded = 'loaded';
/** @private */
export var legendClick = 'legendClick';
/** @private */
export var load = 'load';
/** @private */
export var animationComplete = 'animationComplete';
/** @private */
export var legendRender = 'legendRender';
/** @private */
export var textRender = 'textRender';
/** @private */
export var pointRender = 'pointRender';
/** @private */
export var sharedTooltipRender = 'sharedTooltipRender';
/** @private */
export var seriesRender = 'seriesRender';
/** @private */
export var axisLabelRender = 'axisLabelRender';
/** @private */
export var axisLabelClick = 'axisLabelClick';
/** @private */
export var axisRangeCalculated = 'axisRangeCalculated';
/** @private */
export var axisMultiLabelRender = 'axisMultiLabelRender';
/** @private */
export var tooltipRender = 'tooltipRender';
/** @private */
export var chartMouseMove = 'chartMouseMove';
/** @private */
export var chartMouseClick = 'chartMouseClick';
/** @private */
export var chartDoubleClick = 'chartDoubleClick';
/** @private */
export var pointClick = 'pointClick';
/** @private */
export var pointDoubleClick = 'pointDoubleClick';
/** @private */
export var pointMove = 'pointMove';
/** @private */
export var chartMouseLeave = 'chartMouseLeave';
/** @private */
export var chartMouseDown = 'chartMouseDown';
/** @private */
export var chartMouseUp = 'chartMouseUp';
/** @private */
export var zoomComplete = 'zoomComplete';
/** @private */
export var dragComplete = 'dragComplete';
/** @private */
export var selectionComplete = 'selectionComplete';
/** @private */
export var resized = 'resized';
/** @private */
export var beforeResize = 'beforeResize';
/** @private */
export var beforePrint = 'beforePrint';
/** @private */
export var annotationRender = 'annotationRender';
/** @private */
export var scrollStart = 'scrollStart';
/** @private */
export var scrollEnd = 'scrollEnd';
/** @private */
export var scrollChanged = 'scrollChanged';
/** @private */
export var stockEventRender = 'stockEventRender';
/** @private */
export var multiLevelLabelClick = 'multiLevelLabelClick';
/** @private */
export var dragStart = 'dragStart';
/** @private */
export var drag = 'drag';
/** @private */
export var dragEnd = 'dragEnd';
/*** @private*/
export var regSub = /~\d+~/g;
/*** @private*/
export var regSup = /\^\d+\^/g;
/** @private */
export var beforeExport = 'beforeExport';
/** @private */
export var afterExport = 'afterExport';
/** @private */
export var bulletChartMouseClick = 'bulletChartMouseClick';
/** @private */
export var onZooming = 'onZooming';
